export const bookingInnerDetailRoute = 'booking-detail';
export const bookingBaseRoute = 'booking';
export const bookingDetailRoute = 'booking-detail';
export const bookingUpsellRoute = 'upsell';
export const informativeBookingRoute = 'informative';
export const informativePaxCelebrateBookingRoute = 'pax-celebrate';
export const bookingWaitingPageRoute = 'waiting-page';

export const BOOK_SESSION_TOKEN_PARAM = 'sessionToken';
export const BOOK_SEARCH_ID_PARAM = 'searchId';
export const BOOK_SEARCH_AIR_ID_PARAM = 'searchIdAir';
